import React from "react";
var __jsx = React.createElement;
import { Link } from "react-router-dom";
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import Pagination from "./components/Pagination/Pagination";
import stl from "./ReferralListComponent.module.css";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var ReferralListComponent = function ReferralListComponent(_ref) {
  var listType = _ref.listType,
    referralList = _ref.referralList,
    loading = _ref.loading,
    getNextPage = _ref.getNextPage,
    getPrePage = _ref.getPrePage,
    getPageByNumber = _ref.getPageByNumber,
    pageCount = _ref.pageCount,
    currentPage = _ref.currentPage,
    orderId = _ref.orderId;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: stl.referrallist
  }, /*#__PURE__*/React.createElement("h1", null, listType === "delivered" ? t("delivered_cars", {
    ns: "web_tracking"
  }) : listType === "used" ? t("used_referral_codes", {
    ns: "web_tracking"
  }) : ""), /*#__PURE__*/React.createElement("div", {
    className: stl.itemsContainer
  }, !loading ? referralList.map(function (item, i) {
    return /*#__PURE__*/React.createElement("div", {
      className: stl.item,
      key: i
    }, /*#__PURE__*/React.createElement("span", {
      className: stl.name
    }, item.name), /*#__PURE__*/React.createElement("span", {
      className: stl.state
    }, item.status));
  }) : /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 63,
    numberOfLoaders: 10
  }), pageCount && pageCount !== 1 ? /*#__PURE__*/React.createElement("div", {
    className: stl.pagination
  }, /*#__PURE__*/React.createElement(Pagination, {
    getNextPage: getNextPage,
    getPrePage: getPrePage,
    getPageByNumber: getPageByNumber,
    pageCount: pageCount,
    currentPage: currentPage
  })) : null), /*#__PURE__*/React.createElement(Link, {
    to: createUrl("/referral/".concat(orderId))
  }, t("return", {
    ns: "web_tracking"
  })));
};
export default ReferralListComponent;